//React imports
import React, { useState, useEffect, useRef } from 'react';
//---

//CSS imports
import './ServiceLogs.css'
//---

//PrimeReact imports
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { DataScroller } from 'primereact/datascroller';
//---

//Vendors imports
import axios from 'axios';
//---

//Components imports
import { useNotification } from '../NotificationProvider';
import SkeletonLogs from '../skeletons/SkeletonLogs';
//---

//Data requests imports
import {
    getServiceDeploymentContainerLogs,
    getServiceDeploymentApplicationLogs
} from '../../data/ServiceData';
//--


const ServiceLogs = ({ service, engine, onHide, logsType = 'technical' }) => {
    const cancelTokenSource = axios.CancelToken.source();

    const { showNotification } = useNotification();

    const ds = useRef(null);

    const [serviceDeploymentLogs, setServiceDeploymentLogs] = useState([]);

    const [dsInitialized, setDsInitialized] = useState(false);

    const [logsLoading, setLogsLoading] = useState(false);

    useEffect(() => {
        getServiceDeploymentLogsCtlr(engine, service['redis-id'])

        return () => {
            cancelTokenSource.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (dsInitialized) {
            ds.current.reset();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceDeploymentLogs]);

    const getServiceDeploymentLogsCtlr = (engine, serviceRedisID) => {
        setLogsLoading(true);
        if (logsType === 'application') {
            getServiceDeploymentApplicationLogs(cancelTokenSource, engine, serviceRedisID).then(
                data => {
                    if (data.serviceDeploymentLogs) {
                        setServiceDeploymentLogs(data.serviceDeploymentLogs);
                    }
                    setLogsLoading(false);
                    setDsInitialized(true);
                },
                errorMessage => {
                    //A problem due to misconfiguration of the service probably occurred before the folder and clever cloud app were created. 
                    //There are no logs, because the app does not exist on the clever cloud side
                    if (!errorMessage.endsWith('no such file or directory')) {
                        showNotification('error', 'Error', errorMessage, 6000);
                    }
                    setLogsLoading(false);
                    setDsInitialized(true);
                }
            );
        } else {
            getServiceDeploymentContainerLogs(cancelTokenSource, engine, serviceRedisID).then(
                data => {
                    if (data.serviceDeploymentLogs) {
                        setServiceDeploymentLogs(data.serviceDeploymentLogs);
                    }
                    setLogsLoading(false);
                    setDsInitialized(true);
                },
                errorMessage => {
                    //A problem due to misconfiguration of the service probably occurred before the folder and clever cloud app were created. 
                    //There are no logs, because the app does not exist on the clever cloud side
                    if (!errorMessage.endsWith('no such file or directory')) {
                        showNotification('error', 'Error', errorMessage, 6000);
                    }
                    setLogsLoading(false);
                    setDsInitialized(true);
                }
            );
        }
        
    }

    const basicItemTemplate = (data) => {
        return (
            <div className='log-container'>
                <span className="p-mr-2 log-timestamp">{data.timestamp}</span>
                <span className="p-mr-2 log-payload">{`${data.payload}`}</span>
            </div>
        );
    }

    return (
        <div>
            <Dialog
                className='service-logs'
                header={`${logsType} logs - ${service.id}`}
                visible={true}
                maximizable
                modal
                style={{ width: '80vw' }}
                onHide={onHide}
            >
                <div className='p-pt-2'>
                    <Button
                        label="Refresh"
                        icon="pi pi-refresh"
                        className="p-button-outlined p-mb-2"
                        loading={logsLoading}
                        onClick={() => getServiceDeploymentLogsCtlr(engine, service['redis-id'])}
                    />
                </div>
                <div>
                    <div className='p-pt-2' style={{ display: logsLoading ? 'block' : 'none' }}><SkeletonLogs /></div>
                    <div style={{ display: logsLoading ? 'none' : 'block' }}>
                        <DataScroller
                            ref={ds}
                            value={serviceDeploymentLogs}
                            itemTemplate={basicItemTemplate}
                            rows={serviceDeploymentLogs.length}
                            inline
                        />
                    </div>
                </div>

            </Dialog>
        </div>
    );
};


export default ServiceLogs;